<template>
    <layout-default-appbar>
        Atividades
    </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewApontamentoAppBar',
  components: {
    LayoutDefaultAppbar,
  },
};
</script>
